export default __webpack_public_path__ + "fa6d7e32bc58ab92f70ef093768da3c7.png";